// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionDropdown_root__1TqRk {
  position: relative;
  width: 100%;
  min-width: 0;
}

.OptionDropdown_trigger__SGhVo {
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  line-height: 22px;
  height: 22px;
  color: #20202a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.OptionDropdown_trigger__SGhVo:disabled {
  cursor: default;
  opacity: 0.5;
}

.OptionDropdown_trigger__SGhVo:focus-visible {
  outline: 2px solid #20202a;
  outline-offset: 2px;
  border-radius: 4px;
}

.OptionDropdown_menu__1vK1j {
  position: fixed;
  z-index: 1500;
  margin: 0;
  padding: 4px 0;
  list-style: none;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(32, 32, 42, 0.12);
  min-width: max-content;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.OptionDropdown_option__t5POL {
  margin: 0;
  padding: 10px 16px;
  border-radius: 0;
  width: 100%;
  box-sizing: border-box;
  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  color: #545665;
  cursor: pointer;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

.OptionDropdown_option__t5POL:last-child {
  margin-bottom: 0;
}

.OptionDropdown_optionSelected__Tj4Nd,
.OptionDropdown_optionHighlighted__XO0fS {
  color: #3d3f4c;
  background: #e8e8ed;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/OptionDropdown.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;EAC7C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,iGAAiG;EACjG,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".root {\n  position: relative;\n  width: 100%;\n  min-width: 0;\n}\n\n.trigger {\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 22px;\n  height: 22px;\n  color: #20202a;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.trigger:disabled {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.trigger:focus-visible {\n  outline: 2px solid #20202a;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.menu {\n  position: fixed;\n  z-index: 1500;\n  margin: 0;\n  padding: 4px 0;\n  list-style: none;\n  background: #ffffff;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(32, 32, 42, 0.12);\n  min-width: max-content;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.option {\n  margin: 0;\n  padding: 10px 16px;\n  border-radius: 0;\n  width: 100%;\n  box-sizing: border-box;\n  font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #545665;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n}\n\n.option:last-child {\n  margin-bottom: 0;\n}\n\n.optionSelected,\n.optionHighlighted {\n  color: #3d3f4c;\n  background: #e8e8ed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `OptionDropdown_root__1TqRk`,
	"trigger": `OptionDropdown_trigger__SGhVo`,
	"menu": `OptionDropdown_menu__1vK1j`,
	"option": `OptionDropdown_option__t5POL`,
	"optionSelected": `OptionDropdown_optionSelected__Tj4Nd`,
	"optionHighlighted": `OptionDropdown_optionHighlighted__XO0fS`
};
export default ___CSS_LOADER_EXPORT___;
